export default __webpack_public_path__ + "static/media/S-Presso.dc9af78f.png";